import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from "react-router-dom";
import { Button, Select, Snackbar, Alert } from '@mui/material';
import colors from "assets/mavric-theme/base/colors.js";
import typography from "assets/mavric-theme/base/typography";
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import borders from "assets/mavric-theme/base/borders";
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import LicenseHistory_table from 'app_tiles/Customers/LicenseHistory_table';
import Divider from '@mui/material/Divider';
import { getKeyValue } from "common_utils/utils";
import SearchCustomer from 'app_tiles/Customers/SearchCustomer';

import { logout } from "actions/auth";
import { getLicenses, getLicenseHistoryByCustomerId, updateCustomerLicense } from "apis/LicensesApis";
import { activateCustomerAccount, deactivateCustomerAccount, getCustomers, setCustomerAccountTypeToBilled, setCustomerAccountTypeToDemo } from 'apis/CustomersApis';

const { borderRadius } = borders;
const { primary, secondary, text, transparent } = colors;
const { size } = typography;


const LicenseDetails = () => {
    const Token = useSelector(state => state.accessToken);
    const MyStateRole = useSelector(state => state.role);
    const isAccounting = (MyStateRole === "accounting") ? true : false;
    const isSalesOperator = (MyStateRole === "salesoperator") ? true : false;
    const isSalesAdmin = (MyStateRole === "salesadmin") ? true : false;
    const isSupport = (MyStateRole === "support") ? true : false;
    const isDealerAdmin = (MyStateRole === "dealeradmin") ? true : false;
    const isDealerOperator = (MyStateRole === "dealeroperator") ? true : false;
    const [isEditMode, setIsEditMode] = useState(false);
    const [isValid, setIsValid] = useState(false);
    const [licStartDt, setLicStartDt] = useState("");
    const [licEndDt, setLicEndDt] = useState("");
    const [accountStatus, setAccountStatus] = useState(null);
    const [accountType, setAccountType] = useState('');
    const [custDataList, setCustDataList] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState({ customer_id: 0, org_name: "" });
    const licensesHistDataRef = React.useRef([]);
    const licensesDataRef = React.useRef();
    const [licensesData, setLicensesData] = useState([]);
    const [formData, setFormData] = useState(null);
    const MAX_NUM_VIEWS = 200;  //x >= 1 and x <=200
    const PRODUCT_TYPES = ["mavric-cloud", "mavric-monitoring-onprem"];
    const [licensesHistData, setLicensesHistData] = useState([])
    const initialLoadRef = useRef(true);
    const dispatch = useDispatch();
    const history = useHistory();
    const [mergedTableData, setMergedTableData] = useState([]);
    const [refreshTrigger, setRefreshTrigger] = useState(0);
    const [alertState, setAlertState] = useState({ open: false, message: '', severity: 'success' });
    const showAlert = (message, severity = 'success') => {
        setAlertState(prev => ({ ...prev, open: true, message, severity }));
    };

    const columns = [
        { accessorKey: 'org_name', header: 'Customer Name', size: 100 },
        { accessorKey: 'num_probes', header: 'No. of Probes', size: 100 },
        { accessorKey: 'num_views', header: 'No. of Views', size: 100 },
        // { accessorKey: 'num_mosaic_views', header: 'No. of Mosaic Views', size: 100 },
        // { accessorKey: 'num_conf_users', header: 'No. of Conf Users', size: 100 },
    ];

    useEffect(() => {
        // console.log("formData:--------->", formData);
    }, [formData])

    const getLicensesData = () => {
        return new Promise(function (resolve, reject) {
            getLicenses().then((response) => {
                // console.log('getLicensesData : response :', response);
                let licenseData = response;
                if (Array.isArray(response) && response.length > 0) {
                    response.map((licenseRow) => {
                        if (!(licenseRow.lic_ref_value)) {
                            licenseRow['lic_ref_value'] = "";
                        }
                        licenseData.push(licenseRow);
                    });
                }
                //setProcessing(false);
                setLicensesData(licenseData);
                resolve(licenseData);
            }).catch((error) => {
                //setProcessing(false);
                setLicensesData([]);
                let errMessage = '';

                if (error.response) {
                    errMessage = error.response.data.message;
                    if (error.response.status === 401 || error.response.status === 403) {
                        // <Redirect from="/" to="/login" />
                        let jsonPostMsg = { "user_id": UserId, "access_token": Token, "role_id": RoleId };
                        dispatch(logout(jsonPostMsg));
                        history.push('/');
                    }
                } else if (error.request) {
                    errMessage = `${error}`;
                    // The request was made but no response was received
                    console.log(error.request);
                } else {
                    // Something happened in setting up the request that triggered an Error
                    console.log('Error', error.message);
                    errMessage = error.message;
                }
                reject(errMessage);
            });
        });
    };

    const triggerData = () => {
        setRefreshTrigger(prev => prev + 1);
    }

    const handleAlertClose = (event, reason) => {
        if (reason === 'clickaway') return;
        setAlertState({ ...alertState, open: false });
    }


    const getLicenseHistoryDataForCustomerId = (customerId) => {
        return new Promise(function (resolve, reject) {
            getLicenseHistoryByCustomerId(customerId).then((response) => {
                //setProcessing(false);
                // console.log('getLicenseHistoryDataForCustomerId : response :', response);

                if (Array.isArray(response)) {
                    let tmpResponse = [];
                    response.map((row, idx) => {
                        let historyRow = row;
                        if (!(historyRow.lic_ref_value)) {
                            historyRow['lic_ref_value'] = null;
                        }
                        if (!(historyRow.lic_start)) {
                            historyRow['lic_start'] = "";
                        }

                        if (!(historyRow.lic_end)) {
                            historyRow['lic_end'] = "";
                        }

                        tmpResponse.push(historyRow);
                    });
                    // licensesHistDataRef.current = tmpResponse;
                    setLicensesHistData(tmpResponse);
                    resolve(tmpResponse);
                } else {
                    // licensesHistDataRef.current = response;
                    setLicensesHistData(response);
                    resolve(response);
                }
            }).catch((error) => {
                //setProcessing(false);
                licensesHistDataRef.current = [];
                setLicensesHistData([]);
                let errMessage = '';

                if (error.response) {
                    errMessage = error.response.data.message;
                    if (error.response.status === 401 || error.response.status === 403) {
                        let jsonPostMsg = { "user_id": UserId, "access_token": Token, "role_id": RoleId };
                        dispatch(logout(jsonPostMsg));
                        history.push('/login');
                    }
                } else if (error.request) {
                    errMessage = `${error}`;
                    // The request was made but no response was received
                    console.log(error.request);
                } else {
                    // Something happened in setting up the request that triggered an Error
                    console.log('Error', error.message);
                    errMessage = error.message;
                }
                reject(errMessage);
            });
        });
    };

    useEffect(() => {
        // getCustomerData();
        getLicensesData();
    }, []);

    const handleCustDataList = (data) => {
        setCustDataList(data);
        // console.log("setCustDataList1:-------------> ",custDataList);
    }

    const isValidDate = (dateString) => {
        // Expected string format yyyy-mm-dd
        //if ( dateString === null || dateString.trim() === "" || dateString.length != 10) return false;
        //if (!/^\d{4}-\d{2}-\d{2}$/.test(dateString)) return false;

        const parts = dateString.split("-");
        const dateYear = parseInt(parts[0], 10);
        const currentDate = new Date();
        const currentYear = currentDate.getFullYear();

        if (dateYear < (currentYear - 1)) return false;

        const date = new Date(dateString);
        return !isNaN(date) && date.toString() !== 'Invalid Date';
    }

    const checkValidity = () => {
        if (isValidDate(licStartDt.trim()) && isValidDate(licEndDt.trim())) {
            setIsValid(new Date(licStartDt.trim()) <= new Date(licEndDt.trim()));
        } else {
            setIsValid(false);
        }
    };

    const formatDate = (isoDateString) => {
        return String(isoDateString).substring(0, 10);
    }

    useEffect(() => {
        let initLicStartDt = getKeyValue(formData, "lic_start", "");
        let initLicEndDt = getKeyValue(formData, "lic_end", "");
        if (initLicStartDt !== "") setLicStartDt(formatDate(initLicStartDt));
        else setLicStartDt(initLicStartDt);
        if (initLicEndDt !== "") setLicEndDt(formatDate(initLicEndDt));
        else setLicEndDt(initLicEndDt);

    }, [formData]);


    useEffect(() => {
        checkValidity();
    }, [licStartDt, licEndDt]);


    // Function to filter columns based on product type
    const getFilteredColumns = (productType, showNumVms = false) => {

        const baseColumns = columns.filter(col => col.accessorKey.startsWith('num'));

        if (productType === 'mavric-monitoring-onprem' && showNumVms) {
            return [
                ...baseColumns,
                { accessorKey: 'num_vms', header: 'No. of VMs', size: 100 }
            ];
        }

        return baseColumns;
    }



    useEffect(() => {
        licensesDataRef.current = licensesData;
        if (initialLoadRef.current && custDataList.length > 0 && licensesData.length > 0) {
            const defaultCustomer = custDataList[0];
            const defaultLicenseData = licensesData.find(license => license.customer_id === defaultCustomer.customer_id);
            setSelectedCustomer(defaultCustomer);
            getLicenseHistoryDataForCustomerId(defaultCustomer.customer_id);
            setAccountStatus(defaultCustomer.is_active);
            setAccountType(defaultCustomer.act_type);
            if (defaultLicenseData) {
               // setSelectedCustomer(defaultCustomer);
                setFormData({
                    ...defaultCustomer,
                    ...defaultLicenseData
                });
                setIsEditMode(isSupport ? false : true);
            }
            initialLoadRef.current = false;
        }
    }, [licensesData, custDataList,]);



    const handleCustomerChange = async (e) => {
        const selectedOrgName = e.target.value;
        const selectedCustomer = custDataList.find(customer => customer.org_name === selectedOrgName);

        if (selectedCustomer) {
            const selectedLicenseData = licensesData.find(license =>
                license.customer_id === selectedCustomer.customer_id
            );

            setSelectedCustomer(selectedCustomer);
            setLicensesHistData([]);
            setAccountStatus(selectedCustomer.is_active);
            setAccountType(selectedCustomer.act_type);
            await getLicenseHistoryDataForCustomerId(selectedCustomer.customer_id);

            if (selectedLicenseData) {
                setFormData({
                    ...selectedCustomer,
                    ...selectedLicenseData
                });
                setIsEditMode(isSupport ? false : true);

            } else {
                console.log("No license data found for customer ID:", selectedCustomer.customer_id);
                setFormData({});
                setIsEditMode(false);
            }
        }
    };

    const handleChangeLicense = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSaveLicenseData = async (licStartDt, licEndDt) => {
        let licensesObject = null;

        if (formData) {
            if (PRODUCT_TYPES.includes(formData.product_type)) {
                let numProbes = parseInt(getKeyValue(formData, "num_probes", 0));
                let numViews = parseInt(getKeyValue(formData, "num_views", 0));
                let numVM = parseInt(getKeyValue(formData, "num_vms", 2));
                // let numMosaicViews = parseInt(getKeyValue(formData, "num_mosaic_views", 0));
                // let numConfUsrs = parseInt(getKeyValue(formData, "num_conf_users", 0));
                let licRefValue = getKeyValue(formData, "lic_ref_value", "");

                if (((numViews >= 0) && (numViews <= MAX_NUM_VIEWS)) &&
                    ((numProbes >= 0) && (numProbes <= MAX_NUM_VIEWS))
                    // ((numConfUsrs >= 0) && (numConfUsrs <= MAX_NUM_VIEWS))
                    // && ((numMosaicViews > 0) && (numMosaicViews <= MAX_NUM_VIEWS))
                ) {
                    licensesObject = {
                        "num_probes": numProbes,
                        "num_views": numViews,
                        // "num_mosaic_views": numMosaicViews,
                        // "num_conf_users": numConfUsrs,
                        "lic_ref_value": licRefValue.trim(),
                        "lic_start": new Date(licStartDt).toISOString(),
                        "lic_end": new Date(licEndDt).toISOString(),
                    };

                    if (formData.product_type === 'mavric-monitoring-onprem' && formData.show_num_vms) {
                        licensesObject.num_vms = numVM;
                        licensesObject.set_num_vms = true; // true if editable
                    }
                } else {
                    alert("Invalid number of probes or views.");
                    return;

                }
            } else console.log("Product type is not handled:", formData.product_type);

            if (formData.customer_id && formData.customer_id !== null && licensesObject !== null) {
                try {
                    setLicensesHistData([]);
                    await updateCustomerLicense(formData.customer_id, licensesObject);
                    const freshData = await getLicenseHistoryDataForCustomerId(formData.customer_id);
                    setLicensesHistData(freshData);
                    await getLicensesData();
                    setFormData(prev => ({
                        ...prev,
                        ...licensesObject,
                        lic_start: licensesObject.lic_start,
                        lic_end: licensesObject.lic_end
                    }));

                    setIsEditMode(true);
                } catch (error) {
                    console.error("Error updating license data:", error);
                }
            }

        }
        // handleCloseLicenseDialog();
        // setIsEditMode(false);
    }

    const handleSaveCustomerData = async() => {
        let isUpdated = false;
        if (!selectedCustomer || selectedCustomer.customer_id === null) return;
        try {
            let statusUpdated = false;
            let typeUpdated = false;
            if (selectedCustomer.is_active !== accountStatus) {
                if (accountStatus) await activateCustomerAccount(selectedCustomer.customer_id);
                else await deactivateCustomerAccount(selectedCustomer.customer_id);
            } isUpdated = true; statusUpdated = true;
        
            if (selectedCustomer.act_type !== accountType) {
                if (accountType === 'demo') await setCustomerAccountTypeToDemo(selectedCustomer.customer_id);
                else await setCustomerAccountTypeToBilled(selectedCustomer.customer_id);
                isUpdated = true;
                typeUpdated = true;
            }
            if (statusUpdated || typeUpdated) {
                triggerData();
                showAlert("Account details updated successfully!", "success");
            }else {
                showAlert("No changes to save", "info");
            }
        } catch (error) {
            console.error("Error saving account data:", error);
            showAlert("Failed to update account details. Please try again.", "error");
        }
    }


    return (
        <>
            <Box sx={{ marginBottom: 2 }}>
                <SearchCustomer
                    handleChange={handleCustomerChange}
                    custDataList={custDataList}
                    selectedCustomer={selectedCustomer}
                    onCustDataListFetch={handleCustDataList}
                    refreshTrigger={refreshTrigger} 
                />

                <Box sx={{
                    backgroundColor: primary.main,
                    padding: 2,
                    borderRadius: 2,
                }}>

                    {formData && formData.product_type &&
                        (
                            <>
                                {isEditMode ? (
                                    <Grid container spacing={2} direction="row">
                                        <Grid item xs={12} md={7.5} lg={7.5}>
                                            <Typography
                                                variant="body2"
                                                color={secondary.main}
                                                sx={{  fontWeight: 600, paddingBottom: '2px'  }}
                                            >
                                                Edit License Data
                                            </Typography>
                                            <Typography
                                                variant="body2"
                                                fontSize={size.sm}
                                                justifyContent="center"
                                                color={text.main}
                                                sx={{ fontWeight: 400, mb: 1 }}
                                            >
                                                Customer Name:&nbsp;{formData && formData.org_name ? formData.org_name : selectedCustomer.org_name ? selectedCustomer.org_name : ''}
                                            </Typography>
                                            <Grid container spacing={1} direction="row">
                                                {getFilteredColumns(formData.product_type, formData.show_num_vms).map((column) => {
                                                    let minValue = 1, maxValue = 200, defaultValue = '', isReadOnly = false;
                                                    
                                                    if (column.accessorKey === 'num_vms') {
                                                        minValue = 1;
                                                        maxValue = 50;
                                                        defaultValue = 2;
                                                        isReadOnly = !formData.set_num_vms;
                                                    } else if (['num_probes', 'num_views'].includes(column.accessorKey)) {
                                                        minValue = 0;
                                                    }
                                                    return (
                                                        <Grid item xs={12} sm={4} md={4} lg={4} key={column.accessorKey}>
                                                            <Typography
                                                                variant="body2"
                                                                fontSize={size.sm}
                                                                justifyContent="center"
                                                                color={text.main}
                                                                sx={{ fontWeight: 400, marginBottom: '8px' }}
                                                            >
                                                                {column.header}
                                                            </Typography>
                                                            <TextField
                                                                required
                                                                id={column.accessorKey}
                                                                name={column.accessorKey}
                                                                placeholder={column.header}
                                                                value={formData[column.accessorKey] !== null
                                                                    && formData[column.accessorKey] !== undefined
                                                                    ? formData[column.accessorKey] : ''}
                                                                onChange={handleChangeLicense}
                                                                fullWidth
                                                                type={'number'}
                                                                InputProps={{
                                                                    readOnly: column.accessorKey === 'org_name' || isReadOnly,
                                                                    sx: { color: text.main },
                                                                    inputProps: {
                                                                        min: minValue,
                                                                        max: maxValue,
                                                                    },
                                                                }}
                                                                sx={{ color: text.main, borderColor: primary.focus, backgroundColor: transparent.main, borderRadius: borderRadius.md, }}
                                                                InputLabelProps={{ sx: { color: text.main }, }}
                                                            />
                                                        </Grid>
                                                    )
                                                })}
                                                <Grid item xs={12} sm={4} md={4} lg={4} key={'lic_start'}>
                                                    <Typography
                                                        variant="body2"
                                                        fontSize={size.sm}
                                                        justifyContent="center"
                                                        color={text.main}
                                                        sx={{ fontWeight: 400, marginBottom: '8px' }}
                                                    >
                                                        {'Effective Date'}
                                                    </Typography>
                                                    <TextField
                                                        required
                                                        id={'lic_start'}
                                                        name={'lic_start'}
                                                        placeholder={''}
                                                        value={licStartDt}
                                                        onChange={(e) => setLicStartDt(e.target.value)}
                                                        fullWidth
                                                        type={'date'}
                                                        InputProps={{
                                                            readOnly: false,
                                                            sx: { color: text.main },
                                                        }}
                                                        sx={{ color: text.main, borderColor: primary.focus, backgroundColor: transparent.main, borderRadius: borderRadius.md, }}
                                                        InputLabelProps={{ sx: { color: text.main }, }}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={4} md={4} lg={4} key={'lic_end'}>
                                                    <Typography
                                                        variant="body2"
                                                        fontSize={size.sm}
                                                        justifyContent="center"
                                                        color={text.main}
                                                        sx={{ fontWeight: 400, marginBottom: '8px' }}
                                                    >
                                                        {'Expiration Date'}
                                                    </Typography>
                                                    <TextField
                                                        required
                                                        id={'lic_end'}
                                                        name={'lic_end'}
                                                        placeholder={''}
                                                        value={licEndDt}
                                                        onChange={(e) => setLicEndDt(e.target.value)}
                                                        fullWidth
                                                        type={'date'}
                                                        InputProps={{
                                                            readOnly: false,
                                                            sx: { color: text.main },
                                                        }}
                                                        sx={{ color: text.main, borderColor: primary.focus, backgroundColor: transparent.main, borderRadius: borderRadius.md, }}
                                                        InputLabelProps={{ sx: { color: text.main }, }}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={4} md={4} lg={4} key={'lic_ref_value'}>
                                                    <Typography
                                                        variant="body2"
                                                        fontSize={size.sm}
                                                        justifyContent="center"
                                                        color={text.main}
                                                        sx={{ fontWeight: 400, marginBottom: '8px' }}
                                                    >
                                                        {'Notes'}
                                                    </Typography>
                                                    <TextField
                                                        required
                                                        id={'lic_ref_value'}
                                                        name={'lic_ref_value'}
                                                        placeholder={''}
                                                        value={formData['lic_ref_value'] !== null
                                                            && formData['lic_ref_value'] !== undefined
                                                            ? formData['lic_ref_value'] : ''}
                                                        onChange={handleChangeLicense}
                                                        fullWidth
                                                        type={'text'}
                                                        InputProps={{
                                                            readOnly: false,
                                                            sx: { color: text.main },
                                                        }}
                                                        sx={{ color: text.main, borderColor: primary.focus, backgroundColor: transparent.main, borderRadius: borderRadius.md, }}
                                                        InputLabelProps={{ sx: { color: text.main }, }}
                                                    />
                                                </Grid>
                                            </Grid>
                                            <Box display="flex" justifyContent="flex-end" gap={2} mt={2}>
                                                {(isAccounting || isSalesOperator || isSalesAdmin || isDealerAdmin || isDealerOperator) ? (
                                                    <Button
                                                        onClick={() => handleSaveLicenseData(licStartDt, licEndDt)}
                                                        color="secondary"
                                                        variant="contained"
                                                        disabled={!isValid}
                                                        sx={{ borderRadius: "4px", padding: "10px 20px" }}
                                                    >
                                                        Save License Details
                                                    </Button>
                                                ) : null}
                                            </Box>
                                        </Grid>
                                        <Grid item sx={{ display: { xs: 'none', md: 'flex' }, justifyContent: 'center', alignItems: 'stretch', px: 1, }}>
                                            <Divider orientation="vertical" flexItem sx={{ borderColor: primary.light }} />
                                        </Grid>
                                        <Grid item xs={12} md={4} lg={4}>
                                            <Typography
                                                variant="body2"
                                                color={secondary.main}
                                                sx={{ 
                                                    fontWeight: 600, 
                                                    marginBottom: '20px',
                                                    paddingBottom: '8px'
                                                }}
                                            >
                                                Edit Account Data
                                            </Typography>
                                            <Grid container spacing={2} direction="row">
                                                <Grid item xs={12} sm={6} md={12} lg={12}>
                                                    <Typography
                                                        variant="body2"
                                                        fontSize={size.sm}
                                                        color={text.main}
                                                        sx={{ fontWeight: 400, marginBottom: '8px' }}
                                                    >
                                                        Account Status
                                                    </Typography>
                                                    <FormControl fullWidth>
                                                        <Select
                                                            value={accountStatus ? "active" : "inactive"}
                                                            onChange={(e) => setAccountStatus(e.target.value === "active")}
                                                            sx={{ ".MuiSelect-select": { paddingTop: "8px !important", paddingBottom: "8px !important", minHeight: "28px !important", display: "flex", alignItems: "center", fontSize: "1em !important" } }}
                                                        >
                                                            <MenuItem value="active">Active</MenuItem>
                                                            <MenuItem value="inactive">Inactive</MenuItem>
                                                        </Select>
                                                    </FormControl>
                                                </Grid>
                                                <Grid item xs={12} sm={6} md={12} lg={12}>
                                                    <Typography
                                                        variant="body2"
                                                        fontSize={size.sm}
                                                        color={text.main}
                                                        sx={{ fontWeight: 400, marginBottom: '8px' }}
                                                    >
                                                        Account Type
                                                    </Typography>
                                                    <FormControl fullWidth>
                                                        <Select
                                                            value={accountType}
                                                            onChange={(e) => setAccountType(e.target.value)}
                                                            sx={{'.MuiSelect-select': { paddingTop: '8px !important', paddingBottom: '8px !important', minHeight: '28px !important', display: 'flex', alignItems: 'center', fontSize: '1em !important' }}}
                                                        >
                                                            <MenuItem value="billed">Billed</MenuItem>
                                                            <MenuItem value="demo">Demo</MenuItem>
                                                        </Select>
                                                    </FormControl>
                                                </Grid>
                                            </Grid>
                                            <Box display="flex" justifyContent="flex-end" gap={2} mt={2}>
                                                {(isAccounting || isSalesOperator || isSalesAdmin || isDealerAdmin || isDealerOperator) ? (
                                                    <Button
                                                        onClick={() => handleSaveCustomerData()}
                                                        color="secondary"
                                                        variant="contained"
                                                        sx={{ borderRadius: "4px", padding: "10px 20px" }}
                                                    >
                                                        Save Account Details
                                                    </Button>
                                                ) : null}
                                            </Box>
                                            <Snackbar
                                                open={alertState.open}
                                                autoHideDuration={5000}
                                                onClose={handleAlertClose}
                                                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                                            >
                                                <Alert
                                                    onClose={handleAlertClose}
                                                    severity={alertState.severity}
                                                    variant="filled"
                                                    sx={{ width: '100%', '& .MuiAlert-message': { color: 'white.main', fontSize: size.sm }, }}
                                                >
                                                    {alertState.message}
                                                </Alert>
                                            </Snackbar>
                                        </Grid>
                                    </Grid>
                                ) : (
                                    <Grid container spacing={2} direction="row">
                                        <Grid item xs={12} md={7.5} lg={7.5}>
                                            <Typography
                                                variant="body2"
                                                color={secondary.main}
                                                sx={{  fontWeight: 600, paddingBottom: '2px'  }}
                                            >
                                                View License Data
                                            </Typography>
                                            <Typography
                                                variant="body2"
                                                fontSize={size.sm}
                                                justifyContent="center"
                                                color={text.main}
                                                sx={{ fontWeight: 400, mb: 1 }}
                                            >
                                                Customer Name:&nbsp;{formData && formData.org_name ? formData.org_name : selectedCustomer.org_name ? selectedCustomer.org_name : ''}
                                            </Typography>
                                            <Grid container spacing={2} direction="row">
                                                {getFilteredColumns(formData.product_type).map((column) => (
                                                        <Grid item xs={12} sm={4} md={4} lg={4} key={column.accessorKey}>
                                                            <Typography
                                                                variant="body2"
                                                                fontSize={size.sm}
                                                            justifyContent="center"
                                                            color={text.main}
                                                            sx={{ fontWeight: 400, marginBottom: '8px' }}
                                                        >
                                                            {column.header}
                                                        </Typography>
                                                        <TextField
                                                            id={column.accessorKey}
                                                            name={column.accessorKey}
                                                            placeholder={column.header}
                                                            value={formData[column.accessorKey] !== null
                                                                && formData[column.accessorKey] !== undefined
                                                                ? formData[column.accessorKey] : ''}
                                                            fullWidth
                                                            InputProps={{
                                                                readOnly: true,
                                                                sx: { color: text.main, borderColor: primary.focus, backgroundColor: 'transparent', borderRadius: borderRadius.md, },
                                                            }}
                                                            InputLabelProps={{
                                                                sx: { color: text.main },
                                                            }}
                                                        />
                                                    </Grid>
                                                ))}
                                                <Grid item xs={12} sm={4} md={4} lg={4} key={'lic_start'}>
                                                    <Typography
                                                        variant="body2"
                                                        fontSize={size.sm}
                                                        justifyContent="center"
                                                        color={text.main}
                                                        sx={{ fontWeight: 400, marginBottom: '8px' }}
                                                    >
                                                        {'Effective Date'}
                                                    </Typography>
                                                    <TextField
                                                        required
                                                        id={'lic_start'}
                                                        name={'lic_start'}
                                                        placeholder={''}
                                                        value={licStartDt}
                                                        fullWidth
                                                        type={'date'}
                                                        InputProps={{
                                                            readOnly: true,
                                                            sx: { color: text.main },
                                                            inputProps: { min: 1, max: 200, },
                                                        }}
                                                        sx={{ color: text.main, borderColor: primary.focus, backgroundColor: transparent.main, borderRadius: borderRadius.md, }}
                                                        InputLabelProps={{
                                                            sx: { color: text.main },
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={4} md={4} lg={4} key={'lic_end'}>
                                                    <Typography
                                                        variant="body2"
                                                        fontSize={size.sm}
                                                        justifyContent="center"
                                                        color={text.main}
                                                        sx={{ fontWeight: 400, marginBottom: '8px' }}
                                                    >
                                                        {'Expiration Date'}
                                                    </Typography>
                                                    <TextField
                                                        required
                                                        id={'lic_end'}
                                                        name={'lic_end'}
                                                        placeholder={''}
                                                        value={licEndDt}
                                                        fullWidth
                                                        type={'date'}
                                                        InputProps={{
                                                            readOnly: true,
                                                            sx: { color: text.main },
                                                            inputProps: { min: 1, max: 200, },
                                                        }}
                                                        sx={{ color: text.main, borderColor: primary.focus, backgroundColor: transparent.main, borderRadius: borderRadius.md, }}
                                                        InputLabelProps={{
                                                            sx: { color: text.main },
                                                        }}
                                                    />

                                                </Grid>
                                                <Grid item xs={12} sm={4} md={4} lg={4} key={'lic_ref_value'}>
                                                    <Typography
                                                        variant="body2"
                                                        fontSize={size.sm}
                                                        justifyContent="center"
                                                        color={text.main}
                                                        sx={{ fontWeight: 400, marginBottom: '8px' }}
                                                    >
                                                        {'Notes'}
                                                    </Typography>
                                                    <TextField
                                                        required
                                                        id={'lic_ref_value'}
                                                        name={'lic_ref_value'}
                                                        placeholder={''}
                                                        value={formData['lic_ref_value'] !== null
                                                            && formData['lic_ref_value'] !== undefined
                                                            ? formData['lic_ref_value'] : ''}
                                                        fullWidth
                                                        InputProps={{
                                                            readOnly: true,
                                                            sx: { color: text.main, borderColor: primary.focus, backgroundColor: 'transparent', borderRadius: borderRadius.md, },
                                                        }}
                                                        InputLabelProps={{
                                                            sx: { color: text.main },
                                                        }}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid item sx={{ display: { xs: 'none', md: 'flex' }, justifyContent: 'center', alignItems: 'stretch', px: 1, }}>
                                            <Divider orientation="vertical" flexItem sx={{ borderColor: primary.light }} />
                                        </Grid>
                                        <Grid item xs={12} md={4} lg={4}>
                                            <Typography
                                                variant="body2"
                                                color={secondary.main}
                                                sx={{ 
                                                    fontWeight: 600, 
                                                    marginBottom: '20px',
                                                    paddingBottom: '8px'
                                                }}
                                            >
                                                View Account Data
                                            </Typography>
                                            <Grid container spacing={2} direction="row">
                                                <Grid item xs={12} sm={6} md={12} lg={12}>
                                                    <Typography
                                                        variant="body2"
                                                        fontSize={size.sm}
                                                        color={text.main}
                                                        sx={{ fontWeight: 400, marginBottom: '8px' }}
                                                    >
                                                        Account Status
                                                    </Typography>
                                                    <TextField
                                                        required
                                                        id={'account_status'}
                                                        name={'account_status'}
                                                        placeholder={''}
                                                        value={accountStatus ? "active" : "inactive"}
                                                        fullWidth
                                                        InputProps={{
                                                            readOnly: true,
                                                            sx: { color: text.main, borderColor: primary.focus, backgroundColor: 'transparent', borderRadius: borderRadius.md },
                                                        }}
                                                        InputLabelProps={{
                                                            sx: { color: text.main },
                                                        }}
                                                    />
                                                </Grid>

                                                <Grid item xs={12} sm={6} md={12} lg={12}>
                                                    <Typography
                                                        variant="body2"
                                                        fontSize={size.sm}
                                                        color={text.main}
                                                        sx={{ fontWeight: 400, marginBottom: '8px' }}
                                                    >
                                                        Account Type
                                                    </Typography>
                                                   
                                                    <TextField
                                                        required
                                                        id={'acc_type'}
                                                        name={'acc_type'}
                                                        placeholder={''}
                                                        value={accountType}
                                                        fullWidth
                                                        InputProps={{
                                                            readOnly: true,
                                                            sx: { color: text.main, borderColor: primary.focus, backgroundColor: 'transparent', borderRadius: borderRadius.md, },
                                                        }}
                                                        InputLabelProps={{
                                                            sx: { color: text.main },
                                                        }}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                )}
                            </>
                        )
                    }
                    <Divider sx={{ borderColor: primary.divider, mt: 2, mb: 2 }} />
                    <Grid container>
                        <Typography variant="body2" color={secondary.main} sx={{ fontWeight: 600, mb: 1 }} gutterBottom>
                            {'License History'}
                        </Typography>
                        <Box sx={{ width: '100%' }}>
                            {(licensesHistData && Array.isArray(licensesHistData) && (licensesHistData.length > 0)) ? (
                                <LicenseHistory_table
                                    data={licensesHistData}
                                    selectedCustomer={selectedCustomer}
                                />
                            ) : (
                                <Box m={4} p={4} sx={{ display: 'flex', justifyContent: 'center' }}>
                                    <Typography variant="body2" color={text.main} sx={{ fontWeight: 600 }}>No License History</Typography>
                                </Box>
                            )}
                        </Box>
                    </Grid>

                </Box>
            </Box>
        </>
    )
}

export default LicenseDetails
